<div class="screen-loader">
    <p><b>{{ loadingText }}</b></p>
    <div class="spinner"></div>
</div>